import AdminSidebar from "./AdminSidebar"
import { Link } from "react-router-dom"
import "./adminTable.css"
import swal from "sweetalert"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { deleteComment, fetchAllComments } from "../../redux/apiCalls/commentApiCall"

const CommentsTable = () => {
    const dispatch = useDispatch()
    const { comments } = useSelector(state => state.comment)

    useEffect(() => {
        dispatch(fetchAllComments())
    }, [])

    const deleteCommentHandler = (commentId) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this comment!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((isOk) => {
            if (isOk) {
                dispatch(deleteComment(commentId))
            }
        })
    }

    return (
        <section className="table-container">
            <AdminSidebar />
            <div className="table-wrapper">
                <h1 className="table-title">
                    <Link to="/admin-dashboard" className="table-back-btn">
                        <i className="bi bi-arrow-left"></i>
                    </Link>
                    Comments
                </h1>
                {comments.length > 0 ? (
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Count</th>
                                <th>User</th>
                                <th>Comment</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comments.map((item, index) => (
                                <tr key={item._id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <div className="table-image">
                                            <img src={item?.user?.profilePhoto?.url} alt="" className="table-user-image" />
                                            <span className="table-username">{item?.user?.username}</span>
                                        </div>
                                    </td>
                                    <td>{item.text}</td>
                                    <td>
                                        <div className="table-button-group">
                                            <button onClick={() => deleteCommentHandler(item._id)}>Delete Comment</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="no-posts-found">
                        <i className="bi bi-chat-left-text"></i>
                        <h3>No Comments Found</h3>
                        <p>There are no comments available on any post right now.</p>
                    </div>
                )}
            </div>
        </section>
    );
}
export default CommentsTable;